:host {
  display: block;
}

details {
  --number-animation-transform-timing: 200ms;

  border-radius: var(--pine-dimension-xs);

  pds-icon {
    transform: scaleY(1);
  }
}

/* stylelint-disable-next-line */
details[open] {
  background-color: var(--pine-color-background-container);

  summary {
    color: var(--pine-color-text-active);
    font-weight: var(--pine-font-weight-semi-bold);

    pds-icon {
      transform: scaleY(-1);
    }
  }
}

summary {
  background-color: var(--pine-color-background-container);
  border-radius: var(--pine-dimension-xs);
  color: var(--pine-color-text-muted);
  font-family: var(--pine-font-family-body);
  font-size: var(--pine-font-size-body-md);
  font-weight: var(--pine-font-weight-medium);
  letter-spacing: var(--pine-letter-spacing);
  line-height: var(--pine-line-height-body);
  padding-block: calc(var(--pine-dimension-2xs) * 1.5);
  padding-inline-end: var(--pine-dimension-2xs);
  padding-inline-start: var(--pine-dimension-xs);

  // Removes marker on Firefox/Chrome
  /* stylelint-disable-next-line */
  align-items: center;
  display: flex;

  // Removes marker on Safari
  &::-webkit-details-marker {
    display: none;
  }

  &:hover {
    background: var(--pine-color-background-container-hover);
    color: var(--pine-color-text);
    cursor: pointer;
  }

  &:focus-visible {
    outline: var(--pine-outline-focus);
    position: relative;
  }

  pds-icon {
    margin-inline-start: auto;
  }
}

.pds-accordion__body {
  padding-block-end: calc(var(--pine-dimension-sm) + 2);
  padding-inline: calc(var(--pine-dimension-2xs) * 1.5);
}
